exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spacer[data-v-85099696]{display:inline-block;width:100%;padding:30px;border:0 solid #f9fafc}@media screen and (max-width:320px){.spacer[data-v-85099696]{padding:25px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-85099696","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Spacer.vue
// module id = 127
// module chunks = 0